import React from 'react';
import { Sparkles } from 'lucide-react';
import { Button } from './ui/button';

const Hero = () => {
  const scrollToContact = () => {
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative pt-32 pb-20 px-4 overflow-hidden bg-gradient-to-br from-cream-bg via-white to-logo-teal-light">
      {/* Vintage film strip decoration */}
      <div className="absolute top-0 left-0 w-full h-4 bg-repeat-x opacity-20" style={{
        backgroundImage: 'repeating-linear-gradient(90deg, #1B2859 0px, #1B2859 20px, transparent 20px, transparent 40px)'
      }}></div>
      
      <div className="container mx-auto max-w-6xl">
        <div className="text-center space-y-8">
          {/* Vintage badge */}
          <div className="inline-flex items-center gap-2 px-6 py-2 bg-logo-navy text-white rounded-full shadow-lg">
            <Sparkles className="w-4 h-4" />
            <span className="text-sm font-bold tracking-wider">CAPTURING LASTING MEMORIES</span>
          </div>
          
          {/* Main heading */}
          <h2 className="text-5xl md:text-7xl font-bold text-logo-navy vintage-title leading-tight">
            Vintage Photo Booth
            <span className="block text-logo-teal mt-2">For Every Event</span>
          </h2>
          
          <p className="text-xl md:text-2xl text-logo-navy-light max-w-3xl mx-auto leading-relaxed">
            Make your event unforgettable with unlimited instant images, fun props, 
            and a dapper photo booth attendant. Perfect for weddings, parties & corporate events!
          </p>
          
          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center pt-6">
            <Button 
              onClick={scrollToContact}
              className="bg-accent-warm hover:bg-accent-warm/90 text-white px-8 py-6 text-lg rounded-lg shadow-lg hover:shadow-xl transition-all transform hover:scale-105 font-bold"
            >
              Book Your Event
            </Button>
            <Button 
              onClick={() => document.getElementById('pricing')?.scrollIntoView({ behavior: 'smooth' })}
              variant="outline"
              className="border-2 border-logo-navy text-logo-navy hover:bg-logo-navy hover:text-white px-8 py-6 text-lg rounded-lg transition-all font-bold"
            >
              View Pricing
            </Button>
          </div>
          
          {/* Trust indicators */}
          <div className="flex flex-wrap justify-center gap-8 pt-8 text-logo-navy-light">
            <div className="text-center">
              <p className="text-3xl font-bold text-logo-teal">∞</p>
              <p className="text-sm font-semibold">Unlimited Photos</p>
            </div>
            <div className="text-center">
              <p className="text-3xl font-bold text-logo-teal">20</p>
              <p className="text-sm font-semibold">Mile Delivery</p>
            </div>
            <div className="text-center">
              <p className="text-3xl font-bold text-logo-teal">100%</p>
              <p className="text-sm font-semibold">Fun Guaranteed</p>
            </div>
          </div>
        </div>
      </div>
      
      {/* Bottom decoration */}
      <div className="absolute bottom-0 left-0 w-full h-4 bg-repeat-x opacity-20" style={{
        backgroundImage: 'repeating-linear-gradient(90deg, #1B2859 0px, #1B2859 20px, transparent 20px, transparent 40px)'
      }}></div>
    </section>
  );
};

export default Hero;